{#if isMobile}
<li>
    <span class="mh-premium-title {colorClassNames.primary}">
        {text}
    </span>
    <ul>
        {#each items as item, index}
        <li class="plan">
            <!-- Note that it's not currently possible to
            use a simple `class:` directive as Svelte
            has a bug when these are combined with
            `bind:this` and prop spreading. See
            https://github.com/sveltejs/svelte/issues/2707
            for more info. -->
            <a bind:this={itemAnchors[index]} href={item.parameters.href}
                {...normaliseDataAttributes(item.parameters.dataAttributes)}>
                <span class="plan-title">
                    {item.parameters.text}
                </span>
                {#if window.screen.height > 804}
                    <span class="plan-subtitle">
                        {item.parameters.subText}
                    </span>
                {/if}
            </a>
        </li>
        {/each}
    </ul>
</li>
{:else}
<ul>
    {#each items as item, index}
    <li class="plan">
        <!-- Note that it's not currently possible to
        use a simple `class:` directive as Svelte
        has a bug when these are combined with
        `bind:this` and prop spreading. See
        https://github.com/sveltejs/svelte/issues/2707
        for more info. -->
        <a bind:this={itemAnchors[index]} href={item.parameters.href}
            {...normaliseDataAttributes(item.parameters.dataAttributes)}>
            <span class="plan-title">
                {item.parameters.text}
            </span>
            <span>
                {item.parameters.subText}
            </span>
        </a>
    </li>
    {/each}
</ul>
{/if}


<style lang="less">
    @import (less) '@spotify-internal/encore-foundation/web/tokens.css';
    @import (reference) '../../../less/variables.less';

    ul {
        display: block;
        list-style: none;
        padding: 0;
    }

    .plan {
        background-color: var(--gray-15);

        &:hover {
            background-color: var(--solid-black-0);
        }

        a {
            display: flex;
            flex-direction: column;
            text-decoration: none;
            transition: background-color 0.2s ease; 
        }

        .plan-title {
            font-weight: @masthead-font-weight-bold;
            font-size: 18px;
            margin: 4px 0;
            color: var(--solid-white-200);
        }

        span {
            font-size: @masthead-font-size-small;
            color: var(--gray-80)
        }
    }

    @media (min-width: @breakpoint-tablet) {
        ul {
            box-shadow: 0 5px 10px rgba(0, 0, 0, 0.15);
            width: 350px;
            transform: translateZ(-10px);
            transition: all 0.25s ease-in-out;
            transition-delay: 0.25s;
        }

        .plan {
            a {
                padding: 30px;
            }
        }
    }

    @media (max-width: @breakpoint-tablet - 1) {
        .plan {
            margin: 7px 0 7px 25px;
            border-radius: 4px;

            &:last-child {
                margin-bottom: 25px;
            }

            a {
                color: var(--solid-white-200);
                padding: 8px 16px;
            }

            .plan-title {
                font-size: @masthead-font-size-medium;
            }

        }

        .mh-premium-title {
            display: block;
            cursor: pointer;
            line-height: 1;
            padding: 10px 0;
            font-weight: @masthead-font-weight-bold;
            font-size: @masthead-font-size-tablet-large;
        }
    }

    @media (max-width: @breakpoint-mobile-narrow - 1) {
        a {
            font-size: @masthead-font-size-mobile-large;
        }
    }
</style>

<script>
    import { normaliseDataAttributes } from '../../../lib/normaliseDataAttributes';

    export let items;
    export let text;
    export let isMobile = false;
    export let colorClassNames;

    const itemAnchors = [];

    const moveFocus = amount => {
        const focusedIndex = itemAnchors.findIndex(
            item => document.activeElement === item,
        );

        // to ensure index stays in bounds
        itemAnchors[
            Math.max(0, Math.min(focusedIndex + amount, items.length - 1))
        ].focus();
    };

    export const selectNext = () => moveFocus(1);
    export const selectPrevious = () => moveFocus(-1);
</script>